exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#btnSubmitAvg { margin-top: 33px;\n}\n.wrapper-chart { width: 90%; margin-top: 50px;\n}\n", ""]);

// exports
